import { Routes } from '@angular/router';
import { AuthGuard } from 'src/app/shared/guards/auth.guard';
import { EditPage } from './pages/edit/edit.page';
import { DocumentPreviewPage } from './pages/preview/document-preview';

export const documentRoutes: Routes = [
    { path: ':id/preview', component: DocumentPreviewPage },
    { path: ':id/edit', component: EditPage, canActivate: [AuthGuard] },
    /*
     * Sem AuthGuard, como o `:id/preview` ao lado: o webview do app abre esta página SEM sessão
     * na web e prova o acesso com o `?previewToken=`. Quem barra documento privado é o gate do
     * backend (`checkDocumentAccess`), não a rota.
     */
    {
        path: ':id/pdf-preview',
        loadComponent: () =>
            import('./pages/pdf-preview/pdf-preview.page').then((x) => x.PdfPreviewPage),
    },
    /* Sem AuthGuard pelo mesmo motivo do `:id/pdf-preview`: é a tela de capa do webview do
     * app, que chega sem sessão na web e prova o acesso com o `?previewToken=`. */
    {
        path: ':id/cover-preview',
        loadComponent: () =>
            import('./pages/cover-preview/cover-preview.page').then((x) => x.CoverPreviewPage),
    },
];
